import { createContext } from "react"
import { TWidgetsProviderContext } from "./types"


export const WidgetsProviderContext = createContext<TWidgetsProviderContext>({})